import * as React from 'react';
import { Icon, Button, modalStyle } from '@vulcan/vulcan-materialui-theme';
import { IconResources } from 'src/Shared/Constants';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import RequestStore from './RequestStore';

interface Props extends WithStyles<typeof modalStyle> {
  requestStore?: RequestStore;
}

@inject('requestStore')
@observer
class RequestConfirmationErrorDialog extends React.Component<Props> {
  public render(): React.ReactNode {
    const { classes } = this.props;

    const handleClose = (): void => {
      this.props.requestStore!.hideConfirmErrorDialog();
    };

    return (
      <Dialog open={this.props.requestStore!.isConfirmErrorDialogOpen} onClose={handleClose}>
        <DialogTitle className={classes.modalHeader} disableTypography={true}>
          <h4 className={classes.modalTitle}>Please check request lines</h4>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Some products are not available under branch or branch is disabled.
            <br />
            Rollback the request quantity or make stock available under branch on Anvil.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="warning">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }


}

export default withStyles(modalStyle)(RequestConfirmationErrorDialog);
